import React from 'react'

import styles from './player-summary.module.css'

const playerData = {
  "player": {
    "location": "Denver, CO",
    "skills": [
      "html",
      "css",
      "javascript",
      "node",
      "react",
      "wordpress",
      "mysql",
      "php",
      "python",
    ],
    "specialMoves": [
      "fat arrow of reckoning",
      "cyclonic string interpolation",
      "prototype haste",
      "npm fire",
    ]
  }
}

const PlayerSummary = () => (
  <div
		className={styles.playerSummary}
  >
    <div
      className={styles.statRow}
    >
      <span
        className={styles.statLabel}
      >Location:</span>
      <div className={styles.stat}>{playerData.player.location}</div>
    </div>
    <div
      className={styles.statRow}
    >
      <span
        className={styles.statLabel}
      >Skills:</span>
      <div className={styles.stat}>
        <ul
          className={styles.statList}
        >
          {playerData.player.skills.map((skill) => (
            <li
              key={skill}
              className={styles.skill}
            >{skill}</li>
          ))}
        </ul>
      </div>
    </div>

    <div
      className={styles.statRow}
    >
      <span
        className={styles.statLabel}
      >Special moves:</span>
      <div className={styles.stat}>
        <ul
          className={styles.specialMoveList}
        >
          {playerData.player.specialMoves.map((specialMove) => (
            <li
              key={specialMove}
              className={styles.specialMove}
            >{specialMove}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
)

export default PlayerSummary



// WEBPACK FOOTER //
// ./src/components/player-summary.js